import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Flex,
  Text,
  Textarea,
  useDisclosure,
  useToast,
} from '@chakra-ui/react'
import React from 'react'
import { api } from '../../../../services/api'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import * as z from 'zod'
import { user } from '../../../../helpers/user'
import { useMutation } from 'react-query'

async function onRequestRemoveNota({ numero_pedido, observacao, codigo_usuario }) {
  const params = {
    numero_pedido,
    observacao,
    codigo_usuario,
  }

  const response = await api.put('/site/v2/categoria/remover-nota', params)

  return response.data
}

const schema = z.object({
  observacao: z.string().nonempty('Campo obrigatório'),
  numero_pedido: z.string().nonempty('Campo obrigatório'),
  codigo_usuario: z.number(),
})

export function RemoverNota({ item, resultado }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
  })

  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = React.useRef()
  const toast = useToast({
    position: 'top-right',
    duration: 5000,
    isClosable: true,
  })

  const { mutateAsync: onRemoveNota } = useMutation({
    mutationFn: onRequestRemoveNota,
    onSuccess: () => {
      onClose()
      toast({
        title: 'Sucesso!',
        description: 'Nota removida com sucesso!',
        status: 'success',
      })

      resultado({ codParc: '', pedido: '', dataDe: '', dataAte: '', pendente: '', nfe: '' })
    },
    onError: (error) => {
      toast({
        title: 'Erro!',
        description: error.response.data.message,
        status: 'error',
      })
    },
  })

  async function handleRemoveNota(data) {
    await onRemoveNota(data)
  }

  return (
    <>
      <Button onClick={onOpen} colorScheme="red" size="sm">
        Remover Nota
      </Button>
      <AlertDialog motionPreset="slideInBottom" leastDestructiveRef={cancelRef} onClose={onClose} isOpen={isOpen} isCentered>
        <AlertDialogOverlay />

        <AlertDialogContent as="form" onSubmit={handleSubmit(handleRemoveNota)}>
          <AlertDialogHeader>Tem certeza?</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>
            <Text size="sm" color="gray.800" fontWeight="bold" mb={4}>
              Você está prestes a remover a nota do pedido <strong>{item.numero_pedido}</strong>
            </Text>
            <Flex flexDir="column" gap={2}>
              <Text size="sm" color="gray.900" as="label" htmlFor="observacao">
                Digite uma observação
              </Text>
              <input type="hidden" {...register('numero_pedido', { value: item.numero_pedido })} />
              <input type="hidden" {...register('codigo_usuario', { value: user.codigo_usuario })} />
              <Textarea
                border="1px solid"
                borderColor="gray.300"
                id="observacao"
                {...register('observacao')}
                placeholder="Digite uma observação"
                size="sm"
              />
              {errors.observacao && <Text color="red.500">{errors.observacao.message}</Text>}
            </Flex>
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button loadingText="Enviando" type="submit" colorScheme="green">
              Confirmar
            </Button>
            <Button colorScheme="red" ref={cancelRef} onClick={onClose} ml={3}>
              Cancelar
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  )
}
